<template>
  <dynamic-modal
    @apply-cb="apply"
    btn-position="left"
    title="Change email"
    name="change-email-modal"
    :apply-btn="{disabled: applyBtnDisabled, 'typeClass': 'green-btn', 'text': 'Confirm'}">
    <template #body>
      <form @submit.prevent="disableSendFormEmail">
        <div class="info-block">
          <div class="input-field">
            <p>Email: <span>*</span></p>
            <div class="input-field__body ">
              <span class="success-mail" v-if="checkMail && successMessage">{{checkMail}}</span>
              <span class="error-mail" v-if="checkMail && errorMessage">{{checkMail}}</span>
              <div class="input-wrapper">
                <input type="email" v-model="mail" @input="inputMail">
                <LoaderMini :show-mini-loader="isEmailRequesting"/>
              </div>
              <span class="has-error" v-if="errorMail">{{errorMail}}</span>
            </div>
            <div class="input-field__body extra-password-field">
              <p>Current password: <span>*</span></p>
              <input type="password" v-model="password" @input="inputCurrentPassword">
              <span class="has-error" v-if="checkCurrentPassword">{{checkCurrentPassword}}</span>
            </div>
<!--            <div class="input-field__buttons">
              <button class="green-btn"
                      id="change_email_send"
                      v-if="!disabled && !errorReqEmail && validCurrentPasswordForEmail"
                      @click.prevent="changeEmailConfirm" :disabled="requestSend">
                Change Email
              </button>
            </div>-->
          </div>
        </div>
      </form>
    </template>
  </dynamic-modal>
</template>
<script>
  import Vue from "vue";
  import DynamicModal from "@/components/__new_ui_kit/Modal/DynamicModal";
  import debounce from "@/utils/debounce";
  import {email} from "vuelidate/lib/validators";
  import LoaderMini from "@/components/LoaderMini/LoaderMini.vue";

  export default Vue.extend({
    components: {LoaderMini, DynamicModal},
    props: {
      defaultEmail: {type: String}
    },
    data() {
      return {
        checkMail: '',
        successMessage: '',
        errorMessage: '',
        isEmailRequesting: false,
        mail: this.defaultEmail,
        errorReqEmail: false,
        errorMail: '',
        password: '',
        checkCurrentPassword: '',
        requestSend: false
      }
    },
    mounted() {
    },
    computed: {
      applyBtnDisabled() {
        return !this.password.trim().length || this.requestSend || this.mail === this.$props.defaultEmail || !!this.errorMessage
      }
    },
    methods: {
      /* ??? */
      disableSendFormEmail() {
        document.getElementById('change_email_send').click();
        return false;
      },
      inputMail: debounce(function (data) {
        if (data.target.value.length > 0 && email(data.target.value)) {
          this.successMessage = ''
          this.errorMessage = ''
            this.errorMail = ''
            this.errorReqEmail = false
            this.isEmailRequesting = true
            this.$store.dispatch('checkAvailability', {mail: this.mail}).then(res => {
              if (res.status === 200) {
                let success = res.data
                this.successMessage = success.message
                this.errorMessage = ''
                this.checkMail = success.message
                this.isEmailRequesting = false
                if (!success.email) {
                  this.errorReqEmail = false
                } else {
                  this.errorReqEmail = true
                }
              }
              if (res.status === 400) {
                let success = res.data
                this.errorMessage = success.message
                this.successMessage = ''
                this.checkMail = success.message
                this.isEmailRequesting = false
                this.errorReqEmail = true
              }
              if (res.status === 429) {
                this.checkMail = 'Too many requests';
              }
            })
        } else {
          this.checkMail = ""
          this.errorMail = "Invalid email"
          this.errorReqEmail = true
        }
      }, 300),
      inputCurrentPassword(data) {
        this.validCurrentPasswordForEmail = (data.target.value.trim().length > 0);
        this.checkCurrentPassword = false
      },
      apply(applyCb) {
        this.requestSend = true;
        if (!this.errorReqEmail){
          if (this.password.trim().length > 0) {
            this.$store.dispatch('requestToChangeEmail', {
              mail: this.mail,
              current_password: this.password
            }).then((res) => {
              let response = res.data;
              this.requestSend = false;
              if (response.status === 'ok') {
                this.checkMail = response.message;
                this.$store.dispatch('createNotification', {
                  type: 'success',
                  message: response.message})
                this.$router.push('please-activate')
                applyCb(false)
              }
              if (response.status === 'error') {
                this.checkCurrentPassword = response.message;
                applyCb(true)
              }
            })
              .then(() => {
              })
              .catch((err) => {
                console.error(err)
                applyCb(true)
              })
          }
        }
      },
    }
  })
</script>
<style lang="scss" scoped>;
.info-block {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
  margin-right: 15px;
  padding: 15px 0;
  transition: 0.6s;
  .input-field {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    justify-content: flex-start;
    flex-wrap: wrap;
    p {
      width: 100%;
      color: #454545;
      font-weight: 400;
      padding: 0 0 6px 0;
      font-size: 0.9em;
      span {
        color: red;
      }
    }
    &__body {
      width: calc(100% - 55px);
      position: relative;
      .input-wrapper {
        position: relative;
        &::v-deep .loader-mini-wrap {
          position: absolute;
          top: 50%;
          right: -50px;
          transform: translate(0, -50%);
        }
      }
      .success-mail {
        display: block;
        color: #00BF66;
        font-size: 0.85em;
        padding: 0 5px;
        border: 1px solid #d7d7d7;
        border-left: 2px solid #00BF66;
        border-radius: 5px;
        box-shadow: 0 0 20px #00000010;
        font-weight: 600;
        margin: 0 0 5px 0;
      }
      .error-mail {
        display: block;
        color: #EA5252;
        font-size: 0.85em;
        padding: 0 5px;
        border: 1px solid #d7d7d7;
        border-left: 2px solid #EA5252;
        border-radius: 5px;
        box-shadow: 0 0 20px #00000010;
        font-weight: 600;
        margin: 0 0 5px 0;
      }
      .wrapper-example {
        .flag-example {
          position: absolute;
          right: 10px;
        }
      }
      input {
        width: 100%;
        height: 36px;
        border: 1px solid #B5B5B5;
        font-style: normal;
        font-weight: normal;
        font-size: 0.95em;
        padding: 0 10px;
        transition: 0.5s;
      }
      .inp {
        input {
          &::placeholder {
            font-size: 0.9em;
          }
        }
      }
    }
    &__body.extra-password-field {
      margin-top: 10px;
    }
    &__icon {
      width: 55px;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
      margin-bottom: 8px;
      .tooltip-block {
        .tooltip {
          width: 50px;
          left: -15px;
        }
      }
      img {
        margin: 0 5px 0 0;
      }
      .loader-mini-wrap {
        margin: 0;
        img {
          margin: 0;
        }
      }
    }
    &__buttons {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: row;
      padding: 10px 0 0 0;
      button {
        height: 28px;
        max-width: 190px;
        min-height: auto;
        min-width: auto;
        margin: 0 5px 0 0;
      }
      img {
        cursor: pointer;
      }
      span {
        border-radius: 50%;
        width: 20px;
        height: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 0 0 3px;
        cursor: pointer;
        img {
          width: 50%;
        }
      }
      span.green {
        border: 2px solid #00A65A;
      }
      span.red {
        border: 2px solid #f63535;
      }
    }
  }
}
</style>